// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22hl4","content":"styles_content__2bEWr"};